<template>
  <v-container>
    <v-card outlined>
      <v-toolbar dense flat
        >Usuarios
        <v-spacer></v-spacer>
        <menuUsuarioComponent
          @agregarUsuario="agregarUsuario = true"
          @agregarCSV="agregarCSV = true"
        />
      </v-toolbar>
      <v-divider></v-divider>

      <simpleTableComponent
        :headers="headers"
        :items="usuariosList"
        :pagina="pagina"
        :paginas="paginas"
        :totalRegistros="regTotal"
        :registrosPagina="regPagina"
        :search="search"
        :loading="loading"
        @changePage="changePage"
        @searchItem="searchItem"
        @modificarCorreo="modificarCorreo"
        @modificarGenero="actualizarGenero"
        @admin="admin"
        @agregarFoto="agregarFoto"
        @modificarUsuario="actualizarUsuario"
      />
    </v-card>
    <agregarUsuarioComponent
      v-if="agregarUsuario"
      :mostrar="agregarUsuario"
      @cancelar="agregarUsuario = false"
      @usuarioAgregado="usuarioAgregado"
    />
    <agregarUsuariosCSVComponent
      v-if="agregarCSV"
      :mostrar="agregarCSV"
      @cancelar="agregarCSV = false"
      @usuarioAgregado="usuarioAgregado"
    />

    <modificar-correo
      v-if="modificar.mostrar"
      :mostrar="modificar.mostrar"
      :idUsuario="modificar.idUsuario"
      :correo="modificar.correo"
      @cancelar="modificar.mostrar = false"
      @correoModificado="correoModificado"
    />

    <modificar-genero
      v-if="modificarGenero"
      :mostrar="modificarGenero"
      :idUsuario="modificar.idUsuario"
      :genero="modificar.genero"
      @cancelar="modificarGenero = false"
      @generoModificado="generoModificado"
    />

     <foto-component
      v-if="agregar.mostrar"
      :mostrar="agregar.mostrar"
      :idUsuario="agregar.idUsuario"
      @cancelar="agregar.mostrar = false"
      @fotoAgregada="fotoAgregada"
    />

    <modificar-usuario
      v-if="modificarUsuario"
      :mostrar="modificarUsuario"
      :usuario="modificar"
      @cancelar="modificarUsuario = false"
      @usuarioModificado="usuarioModificado"
    />

  </v-container>
</template>

<script>
import { getUsers, adminService } from "./usuarios.service";

import simpleTableComponent from "../mainTemplate/simpleTable.vue";
import menuUsuarioComponent from "./menuUsuarios.vue";
import agregarUsuarioComponent from "./agregarUsuario.vue";
import agregarUsuariosCSVComponent from "./agregarUsuariosCSV.vue";
import ModificarCorreo from "./modificarCorreo.vue";
import ModificarGenero from "./modificarGenero.vue";
import fotoComponent from "./foto.vue"
import ModificarUsuario from "./modificarUsuario.vue"
import { store } from '../../store/store';
export default {
  name: "usuariosView",
  components: {
    simpleTableComponent,
    menuUsuarioComponent,
    agregarUsuarioComponent,
    agregarUsuariosCSVComponent,
    ModificarCorreo,
    ModificarGenero,
    fotoComponent,
    ModificarUsuario
  },
  computed: {
    usuariosList() {
      const usuarios = [];
      let contador = this.pagina * this.regPagina - this.regPagina + 1;
      for (const usuario of this.usuarios) {
        let nuevoUsuario = { numero: contador++, ...usuario };
        nuevoUsuario.foto = usuario.foto
          ? usuario.foto
          : `${store.getters.httpURL}/usuario/foto/${usuario._id}`;
        usuarios.push(nuevoUsuario);
      }
      return usuarios;
    },
  },
  watch: {
    "$route.query"(query) {
      if (query.page != this.pagina) this.pagina = query.page || 1;

      if (query.search) {
        if (query.search != this.search) this.search = query.search;
      }

      this.cargarUsuarios();
    },
  },
  async mounted() {
    this.pagina = this.$route.query.page || 1;
    if (this.$route.query.search) {
      this.pagina = 1;
      this.search = this.$route.query.search;
    }
    this.cargarUsuarios();
  },
  data: () => ({
    loading: false,
    search: "",
    pagina: 1,
    paginas: 2,
    regTotal: 0,
    regPagina: 50,
    headers: [
      {
        text: "#",
        align: "start",
        sortable: false,
        value: "numero",
      },
      { text: "Código", value: "codigo"},
      { text: "Tipo", value: "tipo" },
      { text: "Role", value: "admin" },
      { text: "Género", value: "genero" },
      { text: "Foto", value: "foto" },
      { text: "Nombre", value: "nombre" },
      { text: "Correo", value: "correo" },
      { text: "Teléfono", value: "telefono" },
      { text: "Domicilio", value: "domicilio" },
    ],
    usuarios: [],
    agregarUsuario: false,
    agregarCSV: false,
    modificar: {
      idUsuario: null,
      codigo: null,
      nombre: null,
      correo: null,
      mostrar: false,
      genero: null,
      telefono: null,
      domicilio: null,
    },
    modificarGenero: false,
    modificarUsuario: false,
    agregar:{
      idUsuario: null,
      mostrar: false,
    }

  }),
  methods: {
    async cargarUsuarios() {
      this.usuarios = [];
      try {
        this.loading = true;
        const sendData = {
          pagina: this.pagina,
          search: this.search,
        };
        const serverResponse = await getUsers(sendData);
        this.loading = false;
        if (!serverResponse.ok) throw new Error(serverResponse.mensaje);
        this.usuarios = serverResponse.usuarios;
        this.regTotal = serverResponse.totalUsuarios;
        this.paginas = Math.ceil(this.regTotal / this.regPagina);
      } catch (error) {
        this.loading = false;
        this.$notificarError(error);
      }
    },
    changePage(page) {
      if (page != this.pagina) {
        let query = { page };
        if (this.search.length > 0) query.search = this.search;
        this.changeRoute(query);
      }
    },
    searchItem(search) {
      this.search = search;
      let query = { page: 1 };
      if (search.length > 0) query.search = search;
      this.changeRoute(query);
    },
    changeRoute(query) {
      const route = "/main/usuarios";
      this.$router.push({ path: route, query });
    },
    usuarioAgregado() {
      this.cargarUsuarios();
    },
    modificarCorreo(idUsuario) {
      const usuario = this.usuarios.find((x) => x._id == idUsuario);
      this.modificar.idUsuario = idUsuario;
      this.modificar.correo = usuario.correo;
      this.modificar.mostrar = true;
    },
    correoModificado(data) {
      const index = this.usuarios.findIndex((x) => x._id == data.idUsuario);
      this.usuarios[index].correo = data.correo;
      this.modificar.idUsuario = null;
      this.modificar.correo = null;
      this.modificar.mostrar = false;
    },
    actualizarGenero(idUsuario) {
      const usuario = this.usuarios.find((x) => x._id == idUsuario);
      this.modificar.idUsuario = idUsuario;
      this.modificar.genero = usuario.genero;
      this.modificarGenero = true;
    },
    generoModificado(data) {
      const index = this.usuarios.findIndex((x) => x._id == data.idUsuario);
      this.usuarios[index].genero = data.genero;
      this.modificar.idUsuario = null;
      this.modificar.genero = null;
      this.modificarGenero = false;
    },
    actualizarUsuario(idUsuario) {
      const usuario = this.usuarios.find((x) => x._id == idUsuario);
      this.modificar.idUsuario = idUsuario;
      this.modificar.codigo = usuario.codigo;
      this.modificar.nombre = usuario.nombre;
      this.modificar.correo = usuario.correo;
      this.modificar.genero = usuario.genero;
      this.modificar.telefono = usuario.telefono;
      this.modificar.domicilio = usuario.domicilio;
      this.modificarUsuario = true;
    },
    usuarioModificado(data) {
      const index = this.usuarios.findIndex((x) => x._id == data._id);
      this.usuarios[index].correo = data.correo;
      this.usuarios[index].genero = data.genero;
      this.usuarios[index].telefono = data.telefono;
      this.usuarios[index].domicilio = data.domicilio;
      this.modificar.idUsuario = null;
      this.modificar.codigo = null;
      this.modificar.nombre = null;
      this.modificar.genero = null;
      this.modificar.correo = null;
      this.modificar.telefono.celular = null;
      this.modificar.domicilio = null;
      this.modificarUsuario = false;
    },
    async admin(id){
      try {
        this.loading = true;
     
        const serverResponse = await adminService(id);
        this.loading = false;
        if (!serverResponse.ok) throw new Error(serverResponse.mensaje);
        let index  = this.usuarios.findIndex(x=> x._id==serverResponse.usuario._id);
        this.usuarios[index].admin = serverResponse.usuario.admin;
      } catch (error) {
        this.loading = false;
        this.$notificarError(error);
      }
    },
    agregarFoto(idUsuario) {
      this.agregar.idUsuario = idUsuario;
      this.agregar.mostrar = true;
    },
    fotoAgregada(fotoUrl) {
      try {
        const id = this.agregar.idUsuario;
        if (!id) return;
        const index = this.usuarios.findIndex((x) => x._id == id);
        if (index !== -1) {
          this.$set(this.usuarios, index, { ...this.usuarios[index],
            foto: this.$store.getters.httpURL + `/usuario/foto/${fotoUrl.split('.')[0]}?cb=` + Date.now() });
        }
        this.agregar.idUsuario = null;
        this.agregar.mostrar = false;
      } catch (err) {
        this.$notificarError(err);
      }
    },

  },
};
</script>

<style>
.disable-events {
  pointer-events: none;
  opacity: 0.2;
}
</style>